/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const LS_getUserInfo = /* GraphQL */ `
  query LS_getUserInfo($username: ID!) {
    LS_getUserInfo(username: $username)
  }
`;
export const getOAuthCode = /* GraphQL */ `
  query GetOAuthCode($code: ID!) {
    getOAuthCode(code: $code) {
      code
      sub
      clientId
      redirectUri
      scope
      codeChallenge
      codeChallengeMethod
      exp
      ttl
      updatedAt
      createdAt
      __typename
    }
  }
`;
export const listOAuthCodes = /* GraphQL */ `
  query ListOAuthCodes(
    $code: ID
    $filter: ModelOAuthCodeFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listOAuthCodes(
      code: $code
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        code
        sub
        clientId
        redirectUri
        scope
        codeChallenge
        codeChallengeMethod
        exp
        ttl
        updatedAt
        createdAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listCodeByClientId = /* GraphQL */ `
  query ListCodeByClientId(
    $clientId: String!
    $exp: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOAuthCodeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCodeByClientId(
      clientId: $clientId
      exp: $exp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        code
        sub
        clientId
        redirectUri
        scope
        codeChallenge
        codeChallengeMethod
        exp
        ttl
        updatedAt
        createdAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPhoneAuthCode = /* GraphQL */ `
  query GetPhoneAuthCode($code: ID!) {
    getPhoneAuthCode(code: $code) {
      code
      phone
      countryCode
      name
      gender
      birth
      exp
      ttl
      updatedAt
      createdAt
      __typename
    }
  }
`;
export const listPhoneAuthCodes = /* GraphQL */ `
  query ListPhoneAuthCodes(
    $code: ID
    $filter: ModelPhoneAuthCodeFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listPhoneAuthCodes(
      code: $code
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        code
        phone
        countryCode
        name
        gender
        birth
        exp
        ttl
        updatedAt
        createdAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMemberWithdrawalHistory = /* GraphQL */ `
  query GetMemberWithdrawalHistory($sub: ID!) {
    getMemberWithdrawalHistory(sub: $sub) {
      sub
      providerUserId
      email
      reason
      message
      deletedAt
      updatedAt
      createdAt
      __typename
    }
  }
`;
export const listMemberWithdrawalHistories = /* GraphQL */ `
  query ListMemberWithdrawalHistories(
    $sub: ID
    $filter: ModelMemberWithdrawalHistoryFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listMemberWithdrawalHistories(
      sub: $sub
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        sub
        providerUserId
        email
        reason
        message
        deletedAt
        updatedAt
        createdAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSocialIdentityProvider = /* GraphQL */ `
  query GetSocialIdentityProvider(
    $id: ID!
    $type: SocialIdentityProviderType!
  ) {
    getSocialIdentityProvider(id: $id, type: $type) {
      id
      type
      username
      updatedAt
      createdAt
      __typename
    }
  }
`;
export const listSocialIdentityProviders = /* GraphQL */ `
  query ListSocialIdentityProviders(
    $id: ID
    $type: ModelStringKeyConditionInput
    $filter: ModelSocialIdentityProviderFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSocialIdentityProviders(
      id: $id
      type: $type
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        type
        username
        updatedAt
        createdAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const LS_checkUser = /* GraphQL */ `
  query LS_checkUser(
    $email: String
    $phone: String
    $provider: String
    $providerUserId: String
  ) {
    LS_checkUser(
      email: $email
      phone: $phone
      provider: $provider
      providerUserId: $providerUserId
    )
  }
`;
export const LS_getUserStatus = /* GraphQL */ `
  query LS_getUserStatus($email: String!) {
    LS_getUserStatus(email: $email)
  }
`;
